import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientMasterRoutingModule } from './client-master-routing.module';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientRequestComponent } from './client-request/client-request.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { ClientMasterComponent } from './client-master.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    ClientMasterComponent,
    ClientListComponent,
    ClientRequestComponent,
    ClientDetailsComponent

  ],
  imports: [
    CommonModule,
    ClientMasterRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    DragDropModule,
    InfiniteScrollModule
  ],
  exports: [
    ClientListComponent,
    ClientRequestComponent,
    ClientDetailsComponent
  ]
})
export class ClientMasterModule { }
